import { Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { FooterComponent } from 'shared/components/footer/footer.component';
import { KorviuLogoComponent } from 'shared/components/korviu-logo/korviu-logo.component';
import { LangTranslateBarComponent } from 'shared/components/lang-translate-bar/lang-translate-bar.component';

@Component({
  selector: 'app-welcoming-v2',
  imports: [FooterComponent, KorviuLogoComponent, LangTranslateBarComponent, RouterLink, TranslatePipe],
  templateUrl: './welcoming-v2.component.html',
  styleUrl: './welcoming-v2.component.scss'
})
export class WelcomingV2Component {
  #router = inject(Router);

  onSignUpClick(): void {
    this.#router.navigate(['auth', 'sign-up', 'registration']);
  }

  onPartnerApplicationClick(): void {
    this.#router.navigate(['auth', 'sign-up', 'partner-application']);
  }
}
